import { render, staticRenderFns } from "./kefuMobile.vue?vue&type=template&id=fae3f35c&scoped=true"
import script from "./kefuMobile.vue?vue&type=script&lang=js"
export * from "./kefuMobile.vue?vue&type=script&lang=js"
import style0 from "./kefuMobile.vue?vue&type=style&index=0&id=fae3f35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3f35c",
  null
  
)

export default component.exports